var loginBreadrumb = document.querySelector('#login_breadcrumb');

if (document.body.contains(document.querySelector('.recover-success'))) {
    loginBreadrumb.innerText = "Jelszó visszaállítása" ;
}

const forgetPassBtn = document.getElementById('recover');
const backToLoginBtn = document.getElementById('to-login');

const loginFormContainer = document.querySelector('.login-register-container');
const recoverFormContainer = document.querySelector('.form-recover_password');

const loginUrl = window.location.href

const errorDataSet = document.querySelector(".form-login");
const errorMessage = errorDataSet.dataset.error;
const errorMessageEmail = errorDataSet.dataset.emailError;

if(loginUrl.includes('#recover')){
    loginFormContainer.classList.add('hide');
    recoverFormContainer.classList.remove('hide');
    loginBreadrumb.innerText = "Jelszó visszaállítása" ;
    
}
if(loginUrl.includes('#login')){
    recoverFormContainer.classList.add('hide');
    loginFormContainer.classList.remove('hide');
    loginBreadrumb.innerText = "Bejelentkezés" ;
}




forgetPassBtn.addEventListener('click', function (event) {
    event.preventDefault();

    loginFormContainer.classList.add('hide');
    recoverFormContainer.classList.remove('hide');
    loginBreadrumb.innerText = "Jelszó visszaállítása" ;
    scrollToSmooth()
    
});

backToLoginBtn.addEventListener('click', function (event) {
    event.preventDefault();

    recoverFormContainer.classList.add('hide');
    loginFormContainer.classList.remove('hide');
    loginBreadrumb.innerText = "Bejelentkezés" ;
    scrollToSmooth()
    
});

scrollToSmooth = function (){
    setTimeout(function () {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }, 500);
}

  // Form Validation
  const inputRequiredFields = [...document.querySelectorAll(".form__wrapper .field--input input[required]")];
  inputRequiredFields.forEach( field => {
      field.addEventListener('keyup', function(){
          if(field.value.trim() === ''){
              setErrorFor(field);
          }else {
              setSuccessFor(field);
          }
  console.log("email error", errorMessageEmail)
          if(field.type === 'email' && field.value != '') {
              if(!isEmail(field.value)){
                  setErrorFor(field, errorMessageEmail);
              }else {
                  setSuccessFor(field);
              }
          }
      })
  })
  
  let isValid = true;
  
  function validateForm (e, form) {
        const LoginForm = document.getElementById(form);

        isValid = true;
        e.preventDefault();
        checkInputs(form);
        // console.log(isValid)
        if(isValid){
            LoginForm.submit()
          return true;
        }else {
          focusForm();
          return false;
        }
  }
  
  function checkInputs(form) {
      const requiredFields = document.querySelectorAll(`#${form} .field--input input[required]`);
      const inputFields = [...requiredFields] 
      inputFields.forEach( field => {
          if(field.value.trim() === ''){
              setErrorFor(field);
          }else {
              setSuccessFor(field);
          }
  
          if(field.type === 'email' && field.value != '') {
              if(!isEmail(field.value)){
                  setErrorFor(field, errorMessageEmail);
              }else {
                  setSuccessFor(field);
              }
          }
      });
  }
  
  function setErrorFor(input, errorText = '') {
    const formControl = input.parentElement.parentElement;
    const small = formControl.querySelector('span');
    formControl.classList.add('field--error');
    
    const label = input.getAttribute('data-label');
    const message = `${label} ${errorMessage}`
    small.innerText = errorText != '' ? errorText.trim() : message.trim();
    isValid = false;
  }
  
  function setSuccessFor(input) {
    const formControl = input.parentElement.parentElement;
    const small = formControl.querySelector('span');
    small.innerText = ''
    formControl.classList.remove('field--error');
  }
  function focusForm(){
      const inputRequiredFields = [...document.querySelectorAll(".form__wrapper .field--input input[required]")];
      let  inValidElem = []
      inputRequiredFields.forEach( field => {
          if(field.value.trim() === ''){
              inValidElem.push(field)
          }
          
      })
      inValidElem[0].focus() 
  }
  
  function isEmail(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  }
  
  